import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '分类', path: '/category/all' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-background-50/95 backdrop-blur-md' : 'bg-transparent'}`}>
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
              <span className="text-2xl font-heading text-primary-600">🌸</span>
              <span className="text-xl font-heading font-bold text-foreground-900">樱花漫画</span>
            </Link>

            <div className="hidden md:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                    (link.path === '/' && location.pathname === '/') ||
                    (link.path !== '/' && location.pathname.startsWith(link.path))
                      ? 'text-primary-600'
                      : 'text-foreground-700 hover:text-primary-500'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>

            <div className="hidden md:flex items-center gap-4">
              <div className="relative">
                <input
                  type="text"
                  placeholder="搜索漫画..."
                  className="pl-9 pr-4 py-2 text-sm bg-background-100 border border-background-200/70 rounded-full text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors w-48"
                />
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
              </div>
              <Link
                to="/category/all"
                className="px-5 py-2 text-sm font-medium bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                开始阅读
              </Link>
            </div>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="菜单"
            >
              <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileOpen(false)}
                className={`block py-3 px-4 text-sm font-medium rounded-lg transition-colors ${
                  (link.path === '/' && location.pathname === '/') ||
                  (link.path !== '/' && location.pathname.startsWith(link.path))
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="mt-3 px-4">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-full pl-9 pr-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-full text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400"
              />
            </div>
            <Link
              to="/category/all"
              onClick={() => setMobileOpen(false)}
              className="block mt-3 mx-4 text-center py-2.5 text-sm font-medium bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              开始阅读
            </Link>
          </div>
        )}
      </nav>
      <div className="h-16"></div>
    </>
  );
}